import { alpha } from '@material-ui/core';
import { Box, Button, Paper, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';

const getOrganizationLabel = (organization) => organization?.display || organization?.name || '';

const OrganizationSelectedBox = ({ organization, onChange, disabled }) => {
    const { t } = useTranslation();

    return (
        <Paper
            variant="outlined"
            sx={{
                width: '100%',
                p: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: (theme) => alpha(theme.palette.success.main, 0.08),
                borderColor: (theme) => alpha(theme.palette.success.main, 0.2),
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1.5,
                    flex: 1,
                    minWidth: 0,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: `success.main`,
                        p: 0.75,
                        borderRadius: 1,
                        display: 'flex',
                        alignSelf: 'center',
                    }}
                >
                    <LocalPharmacyIcon sx={{ fontSize: 20, color: '#fff' }} />
                </Box>

                <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75,
                            flexWrap: 'wrap',
                        }}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                color: `success.main`,
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em',
                            }}
                        >
                            {t('Selected organization for prescription')}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 700,
                                color: 'text.primary',
                                wordBreak: 'break-word',
                            }}
                        >
                            {getOrganizationLabel(organization)}
                        </Typography>

                        {organization?.type && (
                            <Box
                                component="span"
                                sx={{
                                    px: 0.75,
                                    py: 0.125,
                                    borderRadius: 1,
                                    fontSize: 11,
                                    fontWeight: 700,
                                    lineHeight: 1.5,
                                    color: `success.dark`,
                                    bgcolor: (theme) => alpha(theme.palette.success.main, 0.14),
                                }}
                            >
                                {organization.type}
                            </Box>
                        )}
                    </Box>

                    {organization?.address && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
                            <LocationOnOutlinedIcon sx={{ fontSize: 16, mt: 0.2, color: 'text.secondary' }} />
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'text.secondary',
                                    lineHeight: 1.35,
                                    wordBreak: 'break-word',
                                }}
                            >
                                {organization.address}
                            </Typography>
                        </Box>
                    )}

                    {organization?.telecom && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                            <PhoneOutlinedIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
                            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                                {organization.telecom}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>

            <Button
                variant="text"
                color={'error'}
                size="small"
                onClick={onChange}
                startIcon={<ClearIcon sx={{ fontSize: 16 }} />}
                disabled={disabled}
                sx={{
                    fontWeight: 500,
                    alignSelf: 'center',
                }}
            >
                {t('Clear')}
            </Button>
        </Paper>
    );
};

export default OrganizationSelectedBox;
